import { render, staticRenderFns } from "./announceCampaignDetail.vue?vue&type=template&id=a818ca30&scoped=true"
import script from "./announceCampaignDetail.vue?vue&type=script&lang=js"
export * from "./announceCampaignDetail.vue?vue&type=script&lang=js"
import style0 from "./announceCampaignDetail.vue?vue&type=style&index=0&id=a818ca30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a818ca30",
  null
  
)

export default component.exports